import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPageA from './pages/LandingPageA';
import LandingPageB from './pages/LandingPageB';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/version-1" replace />} />
          <Route path="/version-1" element={<LandingPageA />} />
          <Route path="/version-2" element={<LandingPageB />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;